import * as React from "react";
import { useAppSelector, useAppDispatch } from "../app/hooks";
import { useParams } from "react-router";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";

//Compontes
import ProdutorCardAboutPage from "../features/produtores/ProdutorCardAboutPage";
import CircularIndeterminate from "../features/LoadingInfo/CircularIndeterminate";
import Appbar from "../features/Appbar/Appbar";

import {
  getListOfFarmersInfo,
  selectlistOfFarmesNameAndAboutMe,
  selectStatusListOfFarmes,
} from "../features/produtores/produtoresSlice";
import theme from "../theme";

type Params = {
  idFarmer: string;
};

interface FarmerInfo {
  docId: string;
  name: string;
  aboutMe: string | null;
  photoUrl: string | null;
}

export default function AboutFarmerPage() {
  const { idFarmer }: Params = useParams();
  const statusListOfFarmes = useAppSelector(selectStatusListOfFarmes);
  const listOfFarmesNameAndAboutMe = useAppSelector(
    selectlistOfFarmesNameAndAboutMe
  );

  const dispatch = useAppDispatch();

  React.useEffect(() => {
    if (statusListOfFarmes === "start") {
      dispatch(getListOfFarmersInfo());
    }
  }, [statusListOfFarmes, dispatch]);

  const [farmer, setfarmer] = React.useState<FarmerInfo | null>(null);

  React.useEffect(() => {
    if (statusListOfFarmes === "success") {
      const foundFarmer = listOfFarmesNameAndAboutMe.find(
        (farmer) => farmer.docId === idFarmer
      );
      if (foundFarmer) {
        console.log("Farmer found =>", foundFarmer);
        setfarmer(foundFarmer);
      }
    }
  }, [statusListOfFarmes, idFarmer, listOfFarmesNameAndAboutMe]);

  return (
    <div style={{ backgroundColor: "#fafafa", minHeight: "100vh" }}>
      <CssBaseline />
      {farmer ? (
        <React.Fragment>
          <Appbar />
          <Container maxWidth="lg">
            <Box
              sx={{
                paddingTop: theme.spacing(8),
                paddingBottom: theme.spacing(6),
                display: "flex",
                justifyContent: "center",
              }}
            >
              <ProdutorCardAboutPage farmer={farmer} />
            </Box>
          </Container>
        </React.Fragment>
      ) : (
        <CircularIndeterminate />
      )}
    </div>
  );
}
